export const downloadFileFromUrl = (url, fileName) => {
  var a = document.createElement('a')
  a.href = url
  a.setAttribute('target', '_blank')
  a.setAttribute('download', fileName)
  a.click()
}
